import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex place-items-center flex-col" }
const _hoisted_2 = { class: "flex w-72 mt-12 .no-print" }
const _hoisted_3 = {
  key: 0,
  class: "mt-3 slide-in"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "uppercase text-4xl font-bold text-violet-950 text-center w-72" }, "Retire o seu ingresso aqui", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "mt-3 slide-in"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "uppercase text-3xl font-bold text-violet-950 text-center w-72" }, "Nenhum ingresso encontrado!", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "mt-3 slide-in no-print"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", { class: "uppercase text-4xl font-bold text-violet-950 text-center w-72" }, "Ingresso encontrado", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 3,
  class: "flutuante flex justify-center items-center text-white bg-gradient-to-r from-pink-700 to-pink-900 no-print"
}
const _hoisted_13 = { class: "flex flex-col mt-16" }
const _hoisted_14 = {
  key: 0,
  class: "text-center font-bold tracking-wide text-lg m-3 slide-in"
}
const _hoisted_15 = {
  key: 1,
  class: "flex flex-col slide-in mt-16"
}
const _hoisted_16 = {
  key: 2,
  class: "flex flex-col slide-in mt-1 printable-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_OptionInputs = _resolveComponent("OptionInputs")!
  const _component_SeuIngresso = _resolveComponent("SeuIngresso")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass([{ 'bg-pink-900': $setup.pagina === 0, 'bg-gray-300': $setup.pagina === 1}, "flex-1 p-1 rounded mr-2 mb-8"])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass([{ 'bg-pink-900': $setup.pagina === 1, 'bg-gray-300': $setup.pagina === 0}, "flex-1 p-1 rounded mr-2 mb-8"])
        }, null, 2)
      ]),
      ($setup.pagina===0 && $setup.erro === false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : ($setup.pagina===1 && $setup.erro === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          : ($setup.pagina===1 && $setup.erro === false && $setup.visible===true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
            : _createCommentVNode("", true),
      ($setup.pagina===1 && $setup.erro === false && $setup.visible===true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.gerarPDF && $options.gerarPDF(...args))),
              class: "no-print"
            }, [
              _createTextVNode(" Baixar "),
              _createVNode(_component_fa, { icon: "fa-solid fa-download" })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        ($setup.pagina===0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Pesquisar por CPF"))
          : _createCommentVNode("", true),
        ($setup.pagina === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_OptionInputs, { onCpfValido: $setup.atualizarPagina }, null, 8, ["onCpfValido"])
            ]))
          : ($setup.pagina === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_SeuIngresso, {
                  cpfValues: $setup.cpfValues,
                  "onLoad:error": $setup.handleErrorLoad,
                  "onSetLoading:load": $setup.setLoading
                }, null, 8, ["cpfValues", "onLoad:error", "onSetLoading:load"])
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createVNode(_component_Loading, null, null, 512), [
        [_vShow, $setup.showLoading]
      ])
    ])
  ], 64))
}